var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8568 1.20745C12.1409 0.481958 10.9784 0.481958 10.2625 1.20745L1.0994 10.4937C0.383533 11.2192 0.383533 12.3974 1.0994 13.1228C1.81527 13.8483 2.97783 13.8483 3.6937 13.1228L9.72988 6.99973V24.8061C9.72988 25.8334 10.5488 26.6633 11.5625 26.6633C12.5762 26.6633 13.3951 25.8334 13.3951 24.8061V7.00554L19.4313 13.117C20.1472 13.8425 21.3097 13.8425 22.0256 13.117C22.7415 12.3916 22.7415 11.2134 22.0256 10.4879L12.8625 1.20164L12.8568 1.20745Z",
    fill: "#87A330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.8641ed97c6c14c46ec037218c91745f3.svg";
export { ForwardRef as ReactComponent };